import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {geoUtils} from '../utils/geo-utils';

class UsaStateHovers extends Component {

  shouldComponentUpdate(nextProps) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;

    return widthDifferent || heightDifferent;
  }

  render() {
    const paths = geoUtils.getAlbersUsaStatePaths(this.props.width, this.props.height);

    const getHandlers = state => {
      const onClick = this.props.onClick;
      const onHoverOver = this.props.onHoverOver;
      const onHoverOut = this.props.onHoverOut;
      const handlers = {};

      if (onClick) {
        handlers.onClick = () => onClick(state.id, state.cent);
      }

      if (onHoverOver) {
        handlers.onMouseEnter = () => onHoverOver(state.id, state.cent);

        if (onHoverOut) {
          handlers.onMouseOut = () => onHoverOut(state.id);
        }
        else {
          handlers.onMouseOut = () => onHoverOver(null);
        }
      }

      return handlers;
    };

    return (
      <g className="UsaStateHovers">
        {paths.map(d => {
          return (
            <path
              key={d.id}
              id={`FIPS_${d.id}`}
              className="hover_out"
              d={d.path}
              {...getHandlers(d)}
            ></path>
          )
        })}
      </g>
    )
  }
}

UsaStateHovers.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  onHoverOver: PropTypes.func,
  onHoverOut: PropTypes.func,
  onClick: PropTypes.func,
};

export default UsaStateHovers


// WEBPACK FOOTER //
// ./src/charts/Map/UsaStateHovers.js